import createAction from '@wix/communities-blog-client-common/dist/src/services/create-action';

export const UPDATE_USER_PRIVACY_STATUS = 'user/UPDATE_USER_PRIVACY_STATUS';

export const updateUserPrivacyStatus = createAction(UPDATE_USER_PRIVACY_STATUS);
